<template>
    <div class="container help" v-if="show">
        <div class="row">
            <div class="col-lg-4">
                <div class="text-muted small">
                    <router-link to="/help" class="text-reset">ヘルプトップへ</router-link>
                </div>
                <h4>その他</h4>
                <other-menu></other-menu>
                <help-menus></help-menus>
            </div>
            <div class="col-lg-8">
                <router-view id="help-manual" v-slot="{Component}">
                    <transition mode="out-in">
                        <component :is="Component" />
                    </transition>
                </router-view>
            </div>
        </div>
    </div>
</template>

<style src="../help.scss" scoped lang="scss"></style>

<script>
import otherMenu from "./other-menu";
import helpMenus from "../help-menus";
export default {
    components: {
        otherMenu,
        helpMenus,
    },
    data() {
        return {
            show: true
        }
    },
}
</script>